import React, { useEffect, useState } from 'react';
import { generateClient } from '@aws-amplify/api';
import { getCallAnalysis } from '@/graphql/queries';
import {
  BsTelephone,
  BsClockHistory,
  BsCheck2Circle,
  BsSlashCircle,
} from 'react-icons/bs';
import ExpandButton from '@/components/ExpandButton';
import { useNavigate } from 'react-router-dom';
import './Widgets.scss';

const client = generateClient();

const format_duration = (s) => `${Math.floor(s / 60)}m ${Math.floor(s % 60)}s`;

const CallAnalysisCard = () => {
  const navigate = useNavigate();

  const [callAnalysis, setCallAnalysis] = useState({});
  const [selectedPeriod] = useState('yearly');
  const [loading, setLoading] = useState(true);

  const handleExpand = () => {
    navigate('/CallAnalysisExpanded');
  };

  useEffect(() => {
    let mounted = true;

    setLoading(true);
    client
      .graphql({ query: getCallAnalysis })
      .then((response) => {
        if (!mounted) return;
        setCallAnalysis(response?.data?.getCallAnalysis || {});
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error loading Call Analysis stats:', err);
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, []);

  const periodData = callAnalysis[selectedPeriod] || {};

  return (
    <div
      className="bg-white px-4 py-3 rounded-3 shadow-sm dashboard-card"
      style={{ border: '1px solid #e0e0e0' }}
    >
      {/* Header */}
      <div
        className="d-flex justify-content-between align-items-center"
        style={{ marginBottom: '0.25rem' }}
      >
        <h6
          className="fw-semibold fs-5 mb-0"
          style={{
            color: '#2E2868',
            display: 'flex',
            position: 'relative',
            position: 'relative',
            top: '-5.5px'

          }}
        >
          Call Analysis
        </h6>

        <div style={{
          display: 'flex',
          position: 'relative'
        }}>
          <div style={{
            position: 'relative',
            top: '-5px'
          }}>
            <ExpandButton onClick={handleExpand} />
          </div>
        </div>

      </div>

      {/* Divider */}
      <div
        style={{
          height: '2px',
          backgroundColor: '#f3f4f6',
          marginTop: '0.1rem',
          marginBottom: '0.25rem',
          width: 'calc(100% + 3rem)',
          marginLeft: '-1.5rem',
        }}
      />

      {/* Body */}
      {loading ? (
        <div className="text-center text-muted py-4">Loading…</div>
      ) : (
        (() => {
          const items = [
            {
              value: periodData.total_calls ?? '-',
              label: 'Total Calls',
              Icon: BsTelephone,
            },
            {
              value: periodData.average_duration_seconds
                ? format_duration(periodData.average_duration_seconds)
                : '-',
              label: 'Avg Duration',
              Icon: BsClockHistory,
            },
            {
              value: periodData.successful ?? '-',
              label: 'Successful Calls',
              Icon: BsCheck2Circle,
            },
            {
              value: periodData.dropped ?? '-',
              label: 'Dropped Calls',
              Icon: BsSlashCircle,
            },
            {
              value: periodData.unanswered ?? '-',
              label: 'No Answer',
              Icon: BsSlashCircle,
            },
            {
              value: periodData.callback_needed ?? '-',
              label: 'Callback Needed',
              Icon: BsSlashCircle,
            },
          ];

          const top = items.slice(0, 3);
          const bottom = items.slice(3);

          const Metric = ({ value, label, Icon, k }) => (
            <div className="col-4 text-center" key={k}>
              <div style={{ fontSize: '1.75rem' }}>{value}</div>
              <div
                className="d-flex justify-content-center align-items-center gap-1 text-capitalize"
                style={{
                  fontSize: '0.9rem',
                  color: '#585485',
                  lineHeight: 1.1,
                  minHeight: '2.2em',
                }}
              >
                <Icon size={18} className="me-1" color="#585485" />
                <span>{label}</span>
              </div>
            </div>
          );

          return (
            <div className="flex-grow-1 d-flex flex-column justify-content-between py-1">
              {/* Top row */}
              <div className="row gx-4 gy-1 text-uppercase" style={{ paddingTop: '40px' }}>
                {top.map((m, i) => (
                  <Metric key={i} {...m} k={`t${i}`} />
                ))}
              </div>

              {/* Bottom row */}
              <div className="row gx-4 gy-1 text-uppercase" style={{ paddingBottom: '40px' }}>
                {bottom.map((m, i) => (
                  <Metric key={i} {...m} k={`b${i}`} />
                ))}
              </div>
            </div>

          );
        })()
      )}
    </div>
  );
};

export default CallAnalysisCard;
